import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import "./ResetPassword.css";
import { updatePasswords } from "../Application/ResetPassword.bussines";
import Storage from "../../Data/Domain/Storage";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const userId = new Storage("id").getItem();

    const payload = {
      oldPassword: values.currentPassword,
      newPassword: values.newPassword,
    };

    setLoading(true);
    try {
      const success = await updatePasswords(userId, payload);
      if (success) {
        message.success("¡Contraseña restablecida correctamente!");
        form.resetFields();
        setIsButtonDisabled(true);
      } else {
        message.warning(
          "No se pudo cambiar la contraseña. Verifique los datos."
        );
      }
    } catch (error) {
      message.error("Error inesperado al cambiar la contraseña.");
    } finally {
      setLoading(false);
    }
  };

  const onFieldsChange = () => {
    const fieldsError = form.getFieldsError();
    const hasErrors = fieldsError.some(({ errors }) => errors.length > 0);
    const fieldsValue = form.getFieldsValue();
    const allFilled = Object.values(fieldsValue).every((val) => val);
    setIsButtonDisabled(hasErrors || !allFilled);
  };

  return (
    <div className="resetPassword-container">
      <div className="resetPassword-formWrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFieldsChange={onFieldsChange}
          className="resetPassword-form"
        >
          <Form.Item
            name="currentPassword"
            label="Contraseña Actual"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su contraseña actual.",
              },
            ]}
          >
            <Input.Password placeholder="Ingrese su contraseña actual" />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="Nueva Contraseña"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su nueva contraseña.",
              },
              {
                pattern: /^(?=.*?[A-Z])(?=.*?[0-9])(?=[^\d\s]*\d)(?=\w*[\W_])\S{8,}$/,
                message:
                  "La contraseña debe tener al menos 8 caracteres, incluir un número, una letra mayúscula y un carácter especial.",
              },
            ]}
            help="La contraseña debe contener un mínimo de 8 caracteres, al menos un número, una letra mayúscula y un carácter especial."
            className="resetPassword-formItem"
          >
            <Input.Password placeholder="Ingrese su nueva contraseña" />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirmar Nueva Contraseña"
            dependencies={["newPassword"]}
            rules={[
              {
                required: true,
                message: "Por favor confirme su nueva contraseña.",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("¡Las contraseñas no coinciden!")
                  );
                },
              }),
            ]}
            extra="Debe coincidir con la nueva contraseña ingresada."
            className="resetPassword-formItem"
          >
            <Input.Password placeholder="Confirme su nueva contraseña" />
          </Form.Item>

          <Form.Item >
            <div className="resetPassword-submitItem">
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
                disabled={isButtonDisabled}
                className="resetPassword-submitButton"
              >
                ENVIAR
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
